module.exports = __webpack_public_path__ + "0bc19ffd9d0c57a10fe11787aa78e7c2.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/favicons/apple_touch_icon_57x57.png
// module id = 310
// module chunks = 0